import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const templateApi = createApi({
  reducerPath: 'templateApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({    
    templates: builder.query<any, void>({
      query: () => 'template',
    }),
    add: builder.mutation<any, any>({
      query: (template: any) => {
        return {
        url: `template`,
        method: 'POST',
        body: template,
      }}
    }),  
    update: builder.mutation<any, any>({
      query: (template: any) => {        
        return {
        url: `template`,
        method: 'PUT',
        body: template,
      }}
    }),
  }),  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useTemplatesQuery, useAddMutation, useUpdateMutation } = templateApi;